export default "__VITE_ASSET__Clpm5yXP__"